"use strict";

module.exports = {
  tag: 'xdr:spPr',
  c: [{
    tag: 'a:xfrm',
    c: [{
      tag: 'a:off',
      $: {
        x: '0',
        y: '0'
      }
    }, {
      tag: 'a:ext',
      $: {
        cx: '0',
        cy: '0'
      }
    }]
  }, {
    tag: 'a:prstGeom',
    $: {
      prst: 'rect'
    },
    c: [{
      tag: 'a:avLst'
    }]
  }]
};
//# sourceMappingURL=sp-pr.js.map



//////////////////
// WEBPACK FOOTER
// ./~/exceljs/dist/es5/xlsx/xform/drawing/sp-pr.js
// module id = 1468
// module chunks = 0